<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col>
        <h1 class="text-center text-h1 indigo--text font-weight-bold">403: Forbidden</h1>
        <h2 class="text-center text-h4 mt-8">You are not allowed to access the page</h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "403",
  };
</script>

<style></style>
